function initSmallLayoutAnimations(){
    //Standard to top link animation
    $('.top-link').on('click',function () {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
    })
    var config = {
        root: null,
        rootMargin: '0px',
        threshold: [0,0.25,0.70, 0.90, 1]
    };

    if (window.matchMedia('(min-width:992px)').matches){
        config = {
            root: null,
            rootMargin: '0px',
            threshold: [0,0.50, 0.90, 1]
        };
    }


    var observer = new IntersectionObserver(function(entries) {
        for (var i = 0; i < entries.length; i++) {
            const element = entries[i].target;
            if (window.matchMedia('(min-width:992px)').matches){
                if(entries[i].intersectionRatio >= 0.40){
                    element.classList.add('element-seen');
                }
            } else{
                if(entries[i].isIntersecting === true){
                    element.classList.add('element-seen');
                }
            }
        }
    }, config);

    setTimeout(function(){
        var elements = document.querySelectorAll('.frame-container-mask_ce_icon_and_text, .frame-container-mask_ce_customer');
        for (var i = 0; i < elements.length; i++) {
            observer.observe(elements[i]);
        }
    },2000)
}